module.exports = __webpack_public_path__ + "static/media/health-check.676a5c46.svg";